import React, { useEffect, useState, forwardRef } from 'react';
import {
    Box,
    Dialog,
    Typography,
    Button,
    Tabs,
    Tab,
    FormControlLabel,
    Switch,
} from '@mui/material';
import Image from 'next/image';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {/* {value === index && ( */}
            <Box sx={{ p: 3 }}>
                <Typography>{children}</Typography>
            </Box>
            {/* )} */}
        </div>
    );
};

const a11yProps = (index) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
};

const AlertPopUp = ({ open, handleClose, alert, editItem, positions }) => {
    // const [isActive, setActive] = React.useState(editItem ? editItem.isActive : true);
    // const [startDate, setStartDate] = useState(
    //     editItem ? new Date(editItem.startDate) : new Date()
    // );
    // const [position, setPosition] = useState(editItem ? editItem.position : null);

    // const handleChange = (event, newValue) => {
    //     setTabValue(newValue);
    // };

    // const [errors, setErrors] = useState({
    //     name: false,
    //     nameEng: false,
    //     position: false,
    // });

    // const onChangeName = (value) => setName(value);
    // const onChangeNameEng = (value) => setNameEng(value);
    // const onChangePosition = (value) => setPosition(value);

    // const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    //     <div
    //         style={{
    //             padding: 12,
    //             border: '1px solid',
    //             borderRadius: 4,
    //             borderColor: '#c4c4c4',
    //         }}
    //         onClick={onClick}
    //         ref={ref}
    //     >
    //         {value}
    //     </div>
    // ));

    // const handleChangeActive = (e) => {
    //     setActive(e.target.checked);
    // };

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            // classes={{
            //     paper: {
            //         borderRadius: 10,
            //         display: 'flex',
            //         flexDirection: 'column',
            //     },
            // }}
            sx={{ padding: 0 }}
        >
            <Image
                // loader={imageLoader}
                width={1}
                height={1}
                src={alert?.imageUrl}
                unoptimized
                layout="responsive"
                alt=""
                objectFit={'contain'}
            />
            <Box
                style={{
                    marginLeft: 'auto',
                }}
            >
                <Button
                    style={{
                        paddingTop: 9,
                        paddingBottom: 9,
                        paddingLeft: 23,
                        paddingRight: 23,
                        borderRadius: 4,
                        fontWeight: '700',
                        fontSize: 12,
                        color: '#6B6F7E',
                    }}
                    onClick={handleClose}
                >
                    Хаах
                </Button>
            </Box>
        </Dialog>
    );
};

export default AlertPopUp;
